import React from 'react';
import Carousel from './Carousel';
import AboutStyleThree from '../pages/AboutStyleThree';
import OfferStyleOne from '../pages/OfferStyleOne';
import TaxiFareOne from '../pages/TaxiFareOne';
import TestimonialsStyleOne from '../pages/TestimonialsStyleOne';
import TaxiStyleOne from '../pages/TaxiStyleOne';
import CtaStyleThree from '../pages/CtaStyleThree ';
import TeamStyleOne from '../pages/TeamStyleOne';
import BlogStyleOne from '../pages/BlogStyleOne';
import CtaStyleTwo from '../pages/CtaStyleTwo';



const HeroSection = () => {
  
  return (

    <div className="th-hero-wrapper hero-1" id="hero">
<Carousel/>
 <AboutStyleThree/>
 <OfferStyleOne/>
<TaxiFareOne/>
<TestimonialsStyleOne/>
<TaxiStyleOne/>
<CtaStyleThree/>
<TeamStyleOne/>
<BlogStyleOne/>
<CtaStyleTwo/>
    </div>
  );
};

export default HeroSection;
